import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import Cropper from 'react-cropper';

import './PhotoCropperPopup.scss';
import './reactCropper.scss';

class PhotoCropperPopup extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      degree: 0,
    };
    this.rotate = this.rotate.bind(this);
    this.handleClickUsePhoto = this.handleClickUsePhoto.bind(this);
  }
  
  handleClickUsePhoto() {
  
    const { onUsePhoto } = this.props;

    if (!this.cropper || (typeof this.cropper.getCroppedCanvas() == 'undefined')) {
      return;
    }

    const cropResult = this.cropper.getCroppedCanvas().toDataURL();

    onUsePhoto(cropResult);
  }

  rotate(e){
    this.cropper.rotateTo(e.target.value);
    this.handleClickUsePhoto();
    this.setState({
      degree: e.target.value,
    });
  }

  render() {
    let marginTop = this.props.marginTop ? this.props.marginTop + 'px' : null;
    return (
      // Replace with the appropriate HTML
        <div className="photo-cropper-container">
          <Cropper
              ready={this.handleClickUsePhoto}
              cropend={this.handleClickUsePhoto}
              style={{ height: 167, width: '100%', marginTop: marginTop }}
              src={this.props.src}
              view={1}
              dragMode='move'
              aspectRatio={1 / 1}
              center={false}
              guides={false}
              ref={cropper => { this.cropper = cropper; }}
              zoomable={false}
          />
          <div className="slider-container">
            <div className="slider-label">{this.textMap.rotatePhoto}</div>
            <input className="slider"type="range" min="-180" max="180" defaultValue="0" onChange={this.rotate} step="1"/>
            <div className="slider-degree">&nbsp;{this.state.degree}&deg;</div>

          </div>
        </div>

    );
  }
}

export default (PhotoCropperPopup);



// WEBPACK FOOTER //
// ./src/components/PhotoCropperPopup/index.js